import { render, staticRenderFns } from "./NotificationTemplate.vue?vue&type=template&id=735caf5d&scoped=true"
import script from "./NotificationTemplate.vue?vue&type=script&lang=js"
export * from "./NotificationTemplate.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplate.vue?vue&type=style&index=0&id=735caf5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735caf5d",
  null
  
)

export default component.exports